module.exports = __webpack_public_path__ + "img/example-garage-kiosk-arrows.39a7380f.png";